import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/get_flats';

const { useQuery } = createQueryData({
  endPoint,
  options: { arrayFormat: 'comma' },
});

export const useRoomsQuery = ({
  params: { houseId, porchIds, stageIds, stepIds } = {},
  options,
} = {}) =>
  useQuery({
    params: { houseId, porchIds, stageIds, stepIds },
    options: { enabled: houseId?.length > 0, ...options },
  });
